import { sellerConstants } from '../../_constants/seller.constants';
import { organisationService } from '../../_services/';

export const organisationListActions = {
    getOrganisations,
};

function getOrganisations(id) {
    return dispatch => {
        dispatch(request());
        organisationService.getOrganisationList(id)
            .then(
                organisations => {
                    dispatch(success(organisations));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_ORGANISATIONS} }
    function success(organisations) { return { type: sellerConstants.RECEIVE_ORGANISATIONS, organisations } }
    function failure(error) { return { type: sellerConstants.ORGANISATINS_ERROR, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/sellers/organisations.actions.js